import AnimatedSection from './AnimatedSection';

export default class extends AnimatedSection {
    constructor(m) {
        super(m);

        this.$block = this.$('block')
    }

    initTl() {
        this.scrollTl = new TimelineMax({})
        for(let i = 0; i < this.$block.length; i++) {
            this.scrollTl.fromTo(this.$block[i], 1, { y: (this.BCR.height * 0.25 * i) }, { y: 0, ease: Power1.easeOut }, 0)
        }
        this.scrollTl.addCallback(() => {}, 1)
        this.scrollTl.pause()
    }
}
